import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center px-5 bg-cream">
            <p className="font-serif text-8xl text-gold">404</p>
            <h1 className="font-serif text-3xl mt-4">Page Not Found</h1>
            <p className="text-muted-foreground mt-3">The page you're looking for doesn't exist.</p>
            <Link to="/" className="inline-block mt-8 bg-gold text-white px-8 py-3.5 text-sm uppercase tracking-[0.15em] hover:bg-gold-hover transition-colors">Back to Home</Link>
        </div>
    );
}
